import { ErrorView } from "@/components/ui/layout/error/errorView"
import { CommentForm, type CommentFormRef } from "@/modules/scores/scoreForms/components/commentForm"
import { ScoreForm } from "@/modules/scores/scoreForms/components/scoreForm"
import type { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import type { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"
import type { SessionBlockExerciseEntity } from "@/modules/sessions/entities/sessionBlockExerciseEntity"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { type SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"
import { Suspense, useRef } from "react"
import { ErrorBoundary } from "react-error-boundary"

export const useScoreCommentFormSidebar = (
  parentSession: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity,
  exercise: SessionBlockExerciseEntity,
) => {
  const { sidebarNavigateTo } = useSidebar()
  const commentFormRef = useRef<CommentFormRef>(null)

  const navigateToScoreForm = (args?: SidebarNavigatorParams) => {
    document.querySelector('[data-slot="right-sidebar-content"]')?.scrollTo({ top: 0 })

    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <ScoreForm exercise={exercise} parentSession={parentSession} />
          </Suspense>
        </ErrorBoundary>
      ),
      ...args,
    })
  }

  const navigateToCommentForm = (args?: SidebarNavigatorParams) => {
    document.querySelector('[data-slot="right-sidebar-content"]')?.scrollTo({ top: 0 })

    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <CommentForm ref={commentFormRef} exercise={exercise} parentSession={parentSession} />
          </Suspense>
        </ErrorBoundary>
      ),
      onHide: () => {
        return commentFormRef.current ? commentFormRef.current.onClose() : Promise.resolve(true)
      },
      ...args,
    })
  }

  return {
    navigateToScoreForm,
    navigateToCommentForm,
  }
}
